export const errorCallback = (message: string, setReload: React.Dispatch<React.SetStateAction<boolean>>, reload: boolean, setToken: React.Dispatch<React.SetStateAction<string>>) => {
    if(message === "fetch timeout") {
        return setReload(!reload)
    }
    return setToken("")
}